import { render, staticRenderFns } from "./HistoryObjectModal.vue?vue&type=template&id=275c457a"
import script from "./HistoryObjectModal.vue?vue&type=script&lang=js"
export * from "./HistoryObjectModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryObjectModal.vue?vue&type=style&index=0&id=275c457a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports